import { Logger } from '@hawtiosrc/core/logging'

export const pluginName = 'hawtio-jmx'
export const pluginPath = '/jmx'
export const log = Logger.get(pluginName)
